import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
var useEffect = React.useEffect;
import { useThrottle } from '@react-hook/throttle';
var emptyArr = [];

var getScrollY = function getScrollY() {
  return window.scrollY !== void 0 ? window.scrollY : window.pageYOffset === void 0 ? 0 : window.pageYOffset;
};

export var useWindowScroll = function useWindowScroll() {
  var fps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;

  var _useThrottle = useThrottle(typeof window === 'undefined' ? 0 : getScrollY, fps, true),
      _useThrottle2 = _slicedToArray(_useThrottle, 2),
      scrollY = _useThrottle2[0],
      setThrottledScroll = _useThrottle2[1];

  function _ref() {
    return setThrottledScroll(getScrollY());
  }

  useEffect(function () {
    var handleScroll = _ref;
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, emptyArr);
  return scrollY;
};
export default useWindowScroll;